import { useQueryErrorResetBoundary } from '@tanstack/react-query'
import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import ApiErrorFallbackSelectBox from '../ErrorFallback/ApiErrorFallbackSelectBox'

const ApiErrorBoundarySelectBox = ({ children }) => {
  const { reset } = useQueryErrorResetBoundary()

  return (
    <ErrorBoundary
      fallbackRender={ApiErrorFallbackSelectBox}
      onReset={reset}
    >
      {children}
    </ErrorBoundary>
  )
}

export default ApiErrorBoundarySelectBox
